export default __webpack_public_path__ + "static/media/coin.d7185127.png";